import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  InputGroup
} from 'reactstrap';

import '../TermsCondition/TermsCondition.css';
import CheckIcon from '@mui/icons-material/Check';
import RenderConditionally from '../../RenderConditionally';
import { TermsConditiontext } from './TermsConditionText';

export default function TermsCondition({ setModal, modal, setTCcheckbBox }) {
  //const [modal, setModal] = useState(true);

  const toggle = () => {
    setModal(!modal);
    setTCcheckbBox(false);
  };
  const AcceptTC = () => {
    setModal(!modal);
    setTCcheckbBox(true);
  };

  return (
    <>
      <RenderConditionally condition={toggle}>
        <Modal isOpen={modal} className='pos-modal'>
          <ModalHeader
            toggle={toggle}
            style={{
              borderBottom: 'none'
            }}
          >
            <div className='Headerstyle'> Terms & Conditions </div>
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <InputGroup>
                <div className='content'>
                  <TermsConditiontext />
                </div>
              </InputGroup>
            </FormGroup>
            <div className='buttonpos flex'>
              <Button className='button' onClick={AcceptTC}>
                <CheckIcon sx={{ fontSize: 22 }} /> Accept T&C
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </RenderConditionally>
    </>
  );
}
